export default "__VITE_ASSET__99671b71__"